import React, {Component} from 'react';
import topBar from '../modules/topBar';
import navbar from '../modules/navbar';
import creatCase from '../modules/creatCase';

class CreatCasePageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  render() {
  	return (
	    <div id="page-creat-case">
        <topBar.container/>
        <div className="bottom-container">
          <navbar.container/>
          <div className="main-section">
            <creatCase.container />
          </div>
        </div>
	    </div>
	  )
  }
}

export default CreatCasePageComponent;
